import { campaignParticipationProvider } from '../../integrations/supabase/campaignParticipationProvider'

export { CampaignPanel } from './CampaignPanel'
export type { CampaignPanelProps } from './CampaignPanel'
export { formatTaskDeadline } from './taskDeadline'

export const campaignParticipationApi = {
  listForOperator: campaignParticipationProvider.listForOperator,
  transition: campaignParticipationProvider.transition,
  setClientVisibility: campaignParticipationProvider.setClientVisibility,
  previewAssignment: campaignParticipationProvider.previewAssignment,
  bulkAssign: campaignParticipationProvider.bulkAssign,
  listClientParticipants: campaignParticipationProvider.listClientParticipants,
}
